<template>
    <div id="authentication">
        <div class="container">
            <p class="text-center d-block mt-5">メール認証完了</p>
            <p>
                メール認証が完了しました。<br>
            </p>
            <el-button @click="top">TOPへ</el-button>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        top() {
            this.$router.push({ path: '/'});
        }
    }
}
</script>

<style scoped>
#authentication {
  position: fixed;
  background: white;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100000;
  text-align: center;
  overflow-y: auto;
}
</style> 